<stages-dialog2 #dialog [dialogAriaLabel]="'error.title' | translate">
	<stages-popup-header [viewedDialog]="dialog" />
	@if (loadingError$ | async; as error) {
		<span class="h1" translate="error.title"></span>
	}

	<stages-popup-content>
		<stages-loading-error-embeddable [credentialsValid]="true" [loadingError$]="loadingError$" />
	</stages-popup-content>
	<stages-popup-footer [viewedDialog]="dialog" />
</stages-dialog2>
